export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-map-pin-line',
      title: '100% Local',
      description: 'Tous nos restaurants et boutiques sont des commerces locaux. Soutenez votre économie de quartier et découvrez les commerçants près de chez vous.'
    },
    {
      icon: 'ri-team-line',
      title: 'Livreurs indépendants',
      description: 'Nos livreurs sont des habitants de votre ville qui connaissent parfaitement les rues et assurent une livraison rapide et soignée.'
    },
    {
      icon: 'ri-time-line',
      title: 'Livraison rapide',
      description: 'Grâce à notre réseau de livreurs locaux, profitez de vos commandes en moyenne sous 30 minutes, du restaurant jusqu\'à votre porte.'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Facile à utiliser',
      description: 'Interface intuitive et simple. Commandez en quelques clics depuis votre ordinateur ou smartphone, où que vous soyez avec Localygo.'
    },
    {
      icon: 'ri-secure-payment-line',
      title: 'Paiement sécurisé',
      description: 'Payez en toute sécurité par carte bancaire. Vos données sont protégées et vos transactions sont cryptées pour votre tranquillité.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Support disponible',
      description: 'Notre équipe est là pour vous aider en cas de besoin. Service client réactif et à l\'écoute pour une expérience sans tracas.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Pourquoi choisir Localygo ?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Une plateforme conçue pour les habitants, par des habitants de votre ville
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mb-6">
                <i className={`${feature.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
